<template>
  <div>
    <div class='row no-gutters detailsRow'>
			<div class='d-none d-sm-block col-3'>
				{{$t('text.applicant')}}
			</div>
			<div class='col detailText'>
				{{traveller1_firstname}} {{traveller1_lastname}}
			</div>
			<div class='col-auto'>
				<a @click='changeStep("ApplicantInfo")' href='javascript:void(0);' :aria-label="$t('text.page12_applicantname')" class='editLink'>{{$t('text.edit')}}</a>
			</div>
    </div>
    <div v-if='this.$store.state.email!==""' class='row no-gutters detailsRow'>
			<div class='d-none d-sm-block col-3'>
				{{$t('text.email')}}
			</div>
			<div class='col detailText'>
				{{email}}
			</div>
			<div class='col-auto'>
				<a @click='changeStep("ApplicantInfo")' href='javascript:void(0);' :aria-label="$t('text.page12_applicantemail')" class='editLink'>{{$t('text.edit')}}</a>
			</div>
    </div>
    <div class='row no-gutters detailsRow' style='border:0px;'>
			<div class='d-none d-sm-block col-3'>
				{{$t('text.details')}}
			</div>
			<div class='col detailText'>
        {{details}}
			</div>
			<div class='col-auto'>
				<a @click='changeStep("TravelPlans")' href='javascript:void(0);' :aria-label="$t('text.page12_applicantdetails')" class='editLink'>{{$t('text.edit')}}</a>
			</div>
    </div>
		<br/>

    <div class='row cartBoxHeader no-gutters'>
      <div class='cartTitle col'>{{this.$store.state.product.Product.Name}}</div>
      <div class='col-auto'>
        <a @click='changeStep("Quote")' href='javascript:void(0);' :sr-only="$t('text.page12_chooseproduct')" class='cartEditLink'>{{$t('text.edit')}}</a>
      </div>
    </div>
		<div class='row cartBox no-gutters'>
			<div class='col-12 col-sm'>
				<div class='cartDetails'>{{benefits}}</div>
			</div>
      <div class='col-12 d-sm-none'><br/></div>
      <div class='col-3 col-sm-1'></div>
      <div class='col-auto text-right' style='padding-right:15px;'>
        <div v-html="$t('text.subtotal')"></div>
        <div v-html="$t('text.taxes')"></div>
        <div style='font-weight:bold;' v-html="$t('text.total')"></div>
      </div>
			<div class='col-auto text-right'>
        <div v-html='premium'></div>
        <div v-html='tax'></div>
				<div style='font-weight:bold;' v-html='totalAmount'></div>

			</div>
		</div>

    <div class='form-row' >
      <label class='col' for='creditcard' v-html='$t("text.page12_input1")'></label>
      <span class='col-auto' style='padding-top:5px;'>
        <img src='../assets/images/VISA.png'>
        <img src='../assets/images/visadebit.png'>
        <img src='../assets/images/mastercard.png'>
        <img src='../assets/images/mc-debit.png'>
      </span>
      <div class='col-12'>
        <input v-model='creditcard' aria-required="true" class='form-control' id='creditcard' :placeholder="$t('text.page12_input1')" maxlength='16' aria-describedby='err_creditcard'/>
      </div>
    </div>
    <div class='form-row'>
      <div class='col-12'>
        <span for='creditcard' class='feedback' id='err_creditcard' tabindex="-1"></span>
      </div>
    </div>

    <div class='form-row' >
      <div class='col-12 col-sm-6'>
        <label for='creditcard_name'>{{$t('text.page12_input2')}} <span class='requiredText' aria-hidden='true'>*</span></label>
        <input v-model='creditcard_name' aria-required="true" class='form-control' id='creditcard_name' :placeholder="$t('text.page12_input2')" maxlength='70' aria-describedby='err_creditcard_name'/>
        <span for='creditcard_name' class='feedback' id='err_creditcard_name' tabindex="-1"></span>
      </div>
      <div class='col-6 col-sm-3'>
        <label for='expiration' style='white-space: nowrap'>{{$t('text.page12_input3')}} <span class='requiredText' aria-hidden='true'>*</span></label>
        <input v-model='expiration' aria-required="true" class='form-control' id='expiration' placeholder="MM/YY" maxlength='7' aria-describedby='err_expiration'/>
        <span for='expiration' class='feedback' id='err_expiration' tabindex="-1"></span>
      </div>
      <div class='col-6 col-sm-3'>
        <img src="../assets/images/CVV.png" style='float:right; margin-top:5px;'>
        <label class='d-block' for='creditcard_cvv' style='white-space:nowrap;'>{{$t('text.page12_input4')}} <span class='requiredText' aria-hidden='true'>*</span></label>
        <input v-model='creditcard_cvv' aria-required="true" class='form-control' id='creditcard_cvv' placeholder="CVV" maxlength='4' aria-describedby='err_creditcard_cvv'/>
        <span for='creditcard_cvv' class='feedback' id='err_creditcard_cvv' tabindex="-1"></span>
      </div>
    </div>

		<div v-show='
    (this.$store.state.product.Product.ProductCode==="CIBCAnnual18Day"||
    this.$store.state.product.Product.ProductCode==="CIBCAnnual8Day"||
    this.$store.state.product.Product.ProductCode==="CIBCIAnnual8Day"||
    this.$store.state.product.Product.ProductCode==="CIBCIAnnual18Day")&&this.$store.state.oldestTraveller<59' class='form-row' style='background-color: #EEEEEE; margin-top:40px;padding:20px;'>
      <div class='col-auto text-center'>
        <b>{{$t('text.optional')}}</b><br/><br/>
        <input v-model="renewAutomatically" class='regular-checkbox' aria-required='false' type='checkbox' id='renewAutomatically' name="renewAutomatically">
      </div>
      <div class='col'>
        <label style='padding-left:15px;' for='renewAutomatically' class='checkbox-label'>
          {{$t('text.page12_autoRenewal')}}
        </label>
        <button v-if='this.$store.state.site==="cibc"' @click="openTooltip($t('text.page12_renewalTooltip'))" name="info-circle" class='helpIcon moreHelp' style='float:right;' :aria-label="$t('text.moreinformation') + $t('text.moreinformation_renewals')">
          <img src='../assets/images/helpIcon_333.png' style='margin-top:0px;' alt=""/>
        </button>
        <button v-else class="moreHelp" @click="openTooltip($t('text.page12_renewalTooltipnm'))" style='float:right;' :aria-label="$t('text.moreinformation') + $t('text.moreinformation_renewals')">
          <img src='../assets/images/helpIcon_333.png' style='margin-top:0px;' alt=""/>
        </button>
      </div>
    </div>
		<div class='form-row' style='background-color: #EEEEEE; margin-top:40px;padding:20px;'>
      <div class='col-auto'>
        <input v-model="confirmTerms" aria-required="true" class='regular-checkbox' type='checkbox' id='confirmTerms' name="confirmTerms" aria-describedby='err_confirmTerms'>
      </div>
      <div class='col'>
        <!-- <label style='padding-left:15px;' for='confirmTerms' class='checkbox-label'>
          {{$t('text.page12_declarationA')}}<a v-if='this.$store.state.site==="cibc"' href="javascript:void(0)" class='certificateLink'>{{$t('text.page12_certificateofinsurance')}}</a><a v-else href="javascript:void(0)" class='certificateLink'>{{$t('text.page12_certificateofinsurancenm')}}</a>{{$t('text.page12_declarationB')}}
          <a v-if='this.$store.state.site==="cibc"' href="javascript:void(0)" class='certificateLink'>{{$t('text.page12_certificateofinsurance')}}</a><a v-else href="javascript:void(0)" class='certificateLink'>{{$t('text.page12_certificateofinsurancenm')}}</a>.
        </label> -->
        <label style='padding-left:15px;' for='confirmTerms' class='checkbox-label'>
          {{$t('text.page12_declarationA')}}<a href="javascript:void(0)" class='certificateLink'>{{$t('text.page12_certificateofinsurance')}}</a>{{$t('text.page12_declarationB')}}
          <a href="javascript:void(0)" class='certificateLink'>{{$t('text.page12_certificateofinsurance')}}</a>.
        </label>
      </div>
    </div>
    <div class='form-row'>
      <span for='confirmTerms' class='feedback' id='err_confirmTerms' tabindex="-1"></span>
    </div>
		<div class='form-row' style='background-color: #EEEEEE; margin-top:40px;padding:20px;'>
			<div class='col-auto'>
      	<input v-model="confirmTermsPrivacyPolicy" aria-required="true" class='regular-checkbox' type='checkbox' id='confirmTermsPrivacyPolicy' name="confirmTermsPrivacyPolicy" aria-describedby='confirmTermsPrivacyPolicy'>
			</div>
      <div class='col'>
        <label  v-html="$t('text.page12_privacy')" for='confirmTermsPrivacyPolicy' class='checkbox-label'></label>
        <!-- <label v-if='this.$store.state.site==="cibc"' v-html="$t('text.page12_privacy')" for='confirmTermsPrivacyPolicy' class='checkbox-label'></label>
        <label v-else v-html="$t('text.page12_privacynm')" for='confirmTermsPrivacyPolicy' class='checkbox-label'></label> -->
      </div>
    </div>
    <div class='form-row'>
      <span for='confirmTermsPrivacyPolicy' class='feedback' id='err_confirmTermsPrivacyPolicy' tabindex="-1" v-html="$t('text.page5_error')"></span>
    </div>
	</div> 
</template>

<script>
import bus from "../utils/bus.js";
import { validationRules } from "../utils/validation_rules.js";
import { validateForm, validateField, callValidationStatusOnBlur } from "../utils/validation.js";
import getLocale from "../utils/getLocale";
import { updateCertificateLinks } from "../utils/updateCertificateLinks.js";

export default {
  data() {
    return {
      traveller1_firstname: this.$store.state.traveller1_firstname,
      traveller1_lastname: this.$store.state.traveller1_lastname,
      email: this.$store.state.email,
    };
  },
  computed: {
    benefits: {
      get(){
        let benefitText="";
        for(const benefit in this.$store.state.product.Product.BenefitsDetails) {
          if (benefit!=="0"){
            benefitText=benefitText+", ";
          }
          benefitText=benefitText+this.$store.state.product.Product.BenefitsDetails[benefit];
        }
        return benefitText;
      }
    },
    premium:{
      get(){
        let price = Number(this.$store.state.product.Premium);
        const res = String(this.$store.state.product.Premium).split(".");
        if(res.length === 1 || res[1].length < 3) {
          price = price.toFixed(2);
        }
        return "$"+price;
      }
    },
    tax:{
      get(){
        let price = Number(this.$store.state.product.Tax);
        const res = String(this.$store.state.product.Tax).split(".");
        if(res.length === 1 || res[1].length < 3) {
          price = price.toFixed(2);
        }
        return "$"+price;
      }
    },
    totalAmount: {
      get() {
        let price = Number(this.$store.state.product.Total);
        const res = String(this.$store.state.product.Total).split(".");
        if(res.length === 1 || res[1].length < 3) {
          price = price.toFixed(2);
        }
        return "$"+price;
      }
    },
    details: {
      get() {
        let detailsText;
        if(this.$store.state.numberOfTravellers>1) {
          detailsText=this.$store.state.numberOfTravellers+" Travellers - ";
        }
        else {
          detailsText="1 "+this.$i18n.t("text.traveller")+" - ";
        }
        if(this.$store.state.product.Product.ProductCode==="CIBCAnnual18Day"||
          this.$store.state.product.Product.ProductCode==="CIBCAnnual8Day"||
          this.$store.state.product.Product.ProductCode==="CIBCIAnnual18Day"||
          this.$store.state.product.Product.ProductCode==="CIBCIAnnual8Day") {
            detailsText = detailsText+this.$store.state.tripStart + " "+this.$i18n.t("text.to")+" " + this.$moment(this.$store.state.tripStart, "MM/DD/YYYY").add(1, "years").subtract(1, "day").format("MM/DD/YYYY");
        }
        else {
          detailsText = detailsText+this.$store.state.departureDate + " "+this.$i18n.t("text.to")+" " + this.$store.state.returnDate;
        }
        return detailsText;
      }
    },
    creditcard: {
      get() {
        return this.$store.state.creditcard;
      },
      set(newValue) {
        validateField(
          document.getElementById("creditcard"),
          newValue,
          validationRules()
        );
      }
    },
    creditcard_name: {
      get() {
        return this.$store.state.creditcard_name;
      },
      set(newValue) {
        validateField(
          document.getElementById("creditcard_name"),
          newValue,
          validationRules()
        );
      }
    },
    expiration: {
      get() {
        return this.$store.state.expiration;
      },
      set(newValue) {
        validateField(
          document.getElementById("expiration"),
          newValue,
          validationRules()
        );
      }
    },
    creditcard_cvv: {
      get() {
        return this.$store.state.creditcard_cvv;
      },
      set(newValue) {
        validateField(
          document.getElementById("creditcard_cvv"),
          newValue,
          validationRules()
        );
      }
    },
    renewAutomatically: {
      get() {
        return this.$store.state.renewAutomatically;
      },
      set(newValue) {
        validateField(
          document.getElementById("renewAutomatically"),
          newValue,
          validationRules()
        );
      }
    },
    confirmTerms: {
      get() {
        return this.$store.state.confirmTerms;
      },
      set(newValue) {
        validateField(
          document.getElementById("confirmTerms"),
          newValue,
          validationRules()
        );
      }
    },
    confirmTermsPrivacyPolicy: {
      get() {
        return this.$store.state.confirmTermsPrivacyPolicy;
      },
      set(newValue) {
        validateField(
          document.getElementById("confirmTermsPrivacyPolicy"),
          newValue,
          validationRules()
        );
      }
    },
  },
  methods: {
    openInNewWindow(url, width, height) {
      const popupWidth = width == null ? 500 : width;
      const popupHeight = height == null ? 600 : height;
      const newWindow = window.open(
        url,
        "popup",
        "scrollbars=1,resizable=1,width=" +
          popupWidth +
          ",height=" +
          popupHeight
      );
    },
    changeStep(targetStep) {
      bus.$emit("changeStep", this.$route.path, targetStep, false);
    },
    openTooltip(text) {
      document.getElementById("keywordBody").innerHTML=text;
      this.$nextTick(()=>{
        document.getElementById("keywordBody").focus();
      });
      bus.$emit("openModal");
    }
  },
  mounted() {
    // Point Certificate/Policy links to the right policy.
    this.$nextTick(() => {     
      updateCertificateLinks(this);
    });

    // FIREFOX BUG FIX - Set listener on checkbox to toggle Aria-Label
    if(navigator.userAgent.toLowerCase().indexOf("firefox") > -1){
      document.getElementById("renewAutomatically").classList.remove("regular-checkbox");
      document.getElementById("confirmTerms").classList.remove("regular-checkbox");
      document.getElementById("confirmTermsPrivacyPolicy").classList.remove("regular-checkbox");
    }

    // If this session already has a policy number, reset the session
    if(this.$store.state.policyNumber!==""){location.reload();}

    // Focus stepTitle for accessibility.
    this.$nextTick( () => {
      document.getElementById("stepTitle").focus();
    });

    // Have fields begin validation on Blur, instead of when navigating to next page.
    callValidationStatusOnBlur(validationRules());
  }
};
</script>

<style>
.detailsRow {
  border-bottom: 1px solid black;
  line-height: 50px;

}
.detailText{
  font-weight: 600;
}
.cartBox {
  border: 1px solid #333333;
  border-bottom-left-radius: 9px;
  border-bottom-right-radius: 9px;
  color: #333333;
  padding: 20px;
  padding-top: 5px;
  line-height: 27px;
  margin-bottom:25px;
}
.cartBoxHeader{
  padding-left: 20px;
  padding-top:5px;
  padding-bottom:5px;
  border-top-left-radius: 9px;
  border-top-right-radius: 9px;
  color: #FFF;
  background-color:#333;
}
.cartTitle {
  font-weight: bold;
}
.cartPrice {
  font-size: 28px;
  font-weight: bold;
}

a.cartEditLink:visited,
a.cartEditLink:link,
a.cartEditLink:active,
a.cartEditLink:hover {
  color: #FFF;
  text-decoration: underline;
  margin-right:20px;
  margin-left:50px;
}

a.editLink:visited,
a.editLink:link,
a.editLink:active,
a.editLink:hover {
  color: #333;
  text-decoration: underline;
}

</style>